import React, { ReactElement } from 'react';
import { Heading, Text } from '@flixbus/honeycomb-react';

import styles from '../voucher-form.module.scss';

interface VoucherFormSectionProps {
  title: string | ReactElement;
  subtitle?: string;
  inputs: React.ReactNode;
}

const VoucherFormSection = ({ title, subtitle, inputs }: VoucherFormSectionProps) => {
  return (
    <div className={styles.section}>
      <div className={styles.title}>
        <Heading Elem='strong' size={3} flushSpace>
          {title}
        </Heading>
        {subtitle && <Text small>{subtitle}</Text>}
      </div>
      <div className={styles.field}>{inputs}</div>
    </div>
  );
};

export default VoucherFormSection;
